import { LANG_OPTIONS } from '@/common/constants/languages';
import { STUDIO_FINAL_OPTION_LABELS } from '../constants/studioFinalOptionLabels';

const PERSONALITY_KIND = 'personality';

export const resolveStudioOptionLabel = (
	quizOptions,
	kind,
	value,
	lang,
) => {
	if (!value) {
		return '';
	}

	const apiKind = kind === PERSONALITY_KIND ? 'personality' : kind;
	const apiOptions = quizOptions?.[apiKind];
	const values = Array.isArray(value) ? value : [value];

	return values
		.map((entry) => {
			const fromApi = apiOptions?.find((option) => option.value === entry)?.label;
			if (fromApi) {
				return fromApi;
			}

			return getStudioOptionLabel(lang, kind, entry);
		})
		.join(' · ');
};

export const getStudioOptionLabel = (lang, category, value) => {
	if (!value) {
		return '';
	}

	const labels =
		STUDIO_FINAL_OPTION_LABELS[lang] ??
		STUDIO_FINAL_OPTION_LABELS[LANG_OPTIONS.english];

	return labels[category]?.[value] ?? value;
};

export const formatStudioOptionValue = (lang, category, value, quizOptions) => {
	if (quizOptions) {
		return resolveStudioOptionLabel(quizOptions, category, value, lang);
	}

	if (Array.isArray(value)) {
		return value
			.map((item) => getStudioOptionLabel(lang, category, item))
			.join(' · ');
	}

	return getStudioOptionLabel(lang, category, value);
};
